@if (loading()) { <app-progress></app-progress> }

<div class="page-content">
  <div class="container-fluid p-0">

<!-- Breadcrumb -->
@if (action().MenuTitle) {
  <div class="px-4 pt-3 pb-2 d-sm-flex align-items-center justify-content-between">
    <div>
      <h4 class="mb-1 fw-semibold" style="color:#0a2540;">
        {{ action().MenuTitle }}
      </h4>
      <p class="text-muted small mb-0">Manage and track all your travel queries</p>
    </div>
    <ol class="breadcrumb mb-0 bg-transparent p-0 mt-2 mt-sm-0">
      <li class="breadcrumb-item">
        <a routerLink="/admin/admin-dashboard" class="text-decoration-none">Dashboard</a>
      </li>
      <li class="breadcrumb-item text-muted">{{ action().ParentMenuTitle }}</li>
      <li class="breadcrumb-item active fw-medium text-primary">{{ action().MenuTitle }}</li>
    </ol>
  </div>
}

    <!-- Full-width Main Card -->
    <div class="card border-0 shadow-sm mx-0 rounded-0">

      <!-- Card Header -->
      <div class="card-header bg-white border-bottom px-4 py-2">
        <div class="d-flex align-items-center justify-content-between flex-wrap gap-3">

          <!-- Title -->
          <div class="d-flex align-items-center gap-2">
            <div class="bg-primary bg-opacity-10 p-2 rounded-3">
              <i class="bx bx-map-alt fs-5 text-primary"></i>
            </div>
            <div>
              <h5 class="mb-0 fw-bold">Trips</h5>
              <span class="small text-muted">
                {{ dataSource.filteredData.length }} trips
              </span>
            </div>
          </div>

          <!-- Search + Filter + Button -->
          <div class="d-flex align-items-center gap-2  flex-wrap">
            <mat-form-field appearance="outline" class="mt-4 me-1 mb-0" style="width:300px;">
              <mat-label>
                <mat-icon>search</mat-icon> Search trips...
              </mat-label>
              <input matInput
                     [(ngModel)]="searchQuery"
                     (ngModelChange)="applyFilter()"
                     placeholder="ID, guest, phone, destination">
              @if (searchQuery) {
                <button matSuffix mat-icon-button (click)="searchQuery=''; applyFilter()">
                  <mat-icon>close</mat-icon>
                </button>
              }
            </mat-form-field>

          

            @if (action().CanCreate) {
              <button 
                mat-raised-button 
                color="primary" 
                class="px-4"
                [routerLink]="'/agent/query-stepone'">
                <mat-icon>add</mat-icon> Add Query
              </button>
            }
          </div>
        </div>
      </div>

      @if (loading()) {
        <mat-progress-bar mode="indeterminate" color="primary"></mat-progress-bar>
      }

      <!-- Body: Sidebar + Table -->
<div class="card-body p-0 d-flex" style="height: calc(100vh - 280px);">

        <!-- ── Left Sidebar Tabs ── -->
        <div class="border-end d-flex flex-column py-3 flex-shrink-0"
             style="width:200px; background:#f8f9fc;">
         
          @for (tab of tabs; track tab.key) {
            <button
              class="btn btn-link text-start text-decoration-none fw-medium
                     d-flex align-items-center justify-content-between px-3 py-2 mx-2 border-0"
              [class.text-primary]="activeTab === tab.key"
              [class.text-secondary]="activeTab !== tab.key"
              [class.bg-white]="activeTab === tab.key"
              [class.shadow-sm]="activeTab === tab.key"
              style="border-radius:8px; font-size:13px;
                     transition:all 0.15s; margin-bottom:2px;"
              (click)="setTab(tab.key)">
              <span class="d-flex align-items-center gap-2">
                <i class="bx fs-5"
                   [class.bx-grid-alt]="tab.key === 'all'"
                   [class.bx-plus-circle]="tab.key === 'new'"
                   [class.bx-loader-circle]="tab.key === 'progress'"
                   [class.bx-pause-circle]="tab.key === 'hold'"
                   [class.bx-check-circle]="tab.key === 'converted'"
                   [class.bx-car]="tab.key === 'ontrip'"
                   [class.bx-calendar-check]="tab.key === 'past'"
                   [class.bx-x-circle]="tab.key === 'canceled'"
                   [class.bx-trash]="tab.key === 'dropped'"></i>
                {{ tab.label }}
              </span>
              @if (getTabCount(tab.key) > 0) {
                <span class="badge rounded-pill"
                      style="font-size:10px;"
                      [class.bg-primary]="activeTab === tab.key"
                      [class.bg-light]="activeTab !== tab.key"
                      [class.text-secondary]="activeTab !== tab.key">
                  {{ getTabCount(tab.key) }}
                </span>
              }
            </button>
          }
        </div>

        <!-- ── Table Area ── -->
        <div class="flex-grow-1 d-flex flex-column overflow-hidden">
          <div class="overflow-auto flex-grow-1">
            <table mat-table [dataSource]="dataSource"
                   matSort matSortActive="id" matSortDirection="desc"
                   class="table align-middle mb-0 w-100"
                   style="font-size:13px;">

              <!-- ID Column -->
              <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef mat-sort-header
                    class="ps-4 py-3 fw-semibold border-bottom bg-light"
                    style="font-size:11px; color:#6b7280; letter-spacing:0.4px; width:100px;">
                  ID / TRIP CODE
                </th>
                <td mat-cell *matCellDef="let row" class="ps-4 py-3 border-bottom">
                  <div class="d-flex align-items-center gap-2">
                    <a class="text-primary fw-semibold text-decoration-none"
                       style="cursor:pointer; font-size:13.5px;"
                       (click)="openTripDetail(row)">
                      #{{ row.id }}
                      <mat-icon style="font-size:14px; vertical-align:middle;
                                       width:14px; height:14px;">
                        chevron_right
                      </mat-icon>
                    </a>
                    @if (row.unread) {
                      <span class="rounded-circle bg-danger d-inline-block"
                            matTooltip="New activity"
                            style="width:7px; height:7px;"></span>
                    }
                  </div>
                </td>
              </ng-container>

              <!-- Contact Column -->
              <ng-container matColumnDef="contact">
                <th mat-header-cell *matHeaderCellDef mat-sort-header
                    class="py-3 fw-semibold border-bottom bg-light"
                    style="font-size:11px; color:#6b7280; letter-spacing:0.4px; width:200px;">
                  CONTACT
                </th>
                <td mat-cell *matCellDef="let row" class="py-3 border-bottom">
                  <div class="fw-semibold text-dark" style="font-size:13.5px;">
                    {{ row.agencyName }}
                  </div>
                  <div class="text-muted d-flex align-items-center gap-1 mt-1"
                       style="font-size:12px;">
                    <span>{{ row.contactName }}</span>
                    @if (row.phone) {
                      <button mat-icon-button
                              style="width:22px; height:22px; line-height:22px;"
                              [matTooltip]="row.phone"
                              (click)="$event.stopPropagation()">
                        <mat-icon style="font-size:13px;">phone</mat-icon>
                      </button>
                    }
                    @if (row.email) {
                      <button mat-icon-button
                              style="width:22px; height:22px; line-height:22px;"
                              [matTooltip]="row.email"
                              (click)="$event.stopPropagation()">
                        <mat-icon style="font-size:13px;">mail_outline</mat-icon>
                      </button>
                    }
                  </div>
                </td>
              </ng-container>

              <!-- Details Column -->
              <ng-container matColumnDef="details">
                <th mat-header-cell *matHeaderCellDef mat-sort-header
                    class="py-3 fw-semibold border-bottom bg-light"
                    style="font-size:11px; color:#6b7280; letter-spacing:0.4px;">
                  TRIP DETAILS
                </th>
                <td mat-cell *matCellDef="let row" class="py-3 border-bottom">
                  <div class="fw-medium">{{ row.destination }}</div>
                  <div class="text-muted mt-1" style="font-size:11.5px;">
                    <i class="bx bx-calendar me-1"></i>
                    {{ row.date }} &bull; {{ row.nights }}N &bull; {{ row.rooms }}
                  </div>
                </td>
              </ng-container>

              <!-- Team Column -->
              <ng-container matColumnDef="team">
                <th mat-header-cell *matHeaderCellDef mat-sort-header
                    class="py-3 fw-semibold border-bottom bg-light"
                    style="font-size:11px; color:#6b7280; letter-spacing:0.4px;">
                  ASSIGNED TO
                </th>
                <td mat-cell *matCellDef="let row" class="py-3 border-bottom">
                  <div class="d-flex align-items-center gap-2">
                    <div class="bg-primary bg-opacity-10 rounded-circle
                                d-flex align-items-center justify-content-center flex-shrink-0"
                         style="width:30px; height:30px;">
                      <span class="text-primary fw-bold" style="font-size:12px;">
                        {{ row.assignee.charAt(0).toUpperCase() }}
                      </span>
                    </div>
                    <div>
                      <div class="fw-medium" style="font-size:12.5px;">
                        {{ row.assignee }}
                      </div>
                      <div class="text-muted" style="font-size:11px;">
                        <i class="bx bx-time-five me-1"></i>{{ row.lastActivity }}
                      </div>
                    </div>
                  </div>
                </td>
              </ng-container>

              <!-- Tags Column -->
              <ng-container matColumnDef="tags">
                <th mat-header-cell *matHeaderCellDef
                    class="py-3 fw-semibold border-bottom bg-light"
                    style="font-size:11px; color:#6b7280; letter-spacing:0.4px;">
                  TAGS
                </th>
                <td mat-cell *matCellDef="let row" class="py-3 border-bottom">
                  <div class="d-flex flex-wrap gap-1">
                    @for (tag of row.tags; track tag) {
                      <span class="badge rounded-pill border border-secondary
                                   text-secondary fw-normal"
                            style="font-size:11px; background:#f3f4f6;">
                        {{ tag }}
                      </span>
                    }
                    @if (row.tags.length === 0) {
                      <span class="text-muted fst-italic small">—</span>
                    }
                  </div>
                </td>
              </ng-container>

              <!-- Status Column -->
              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef mat-sort-header
                    class="py-3 fw-semibold border-bottom bg-light"
                    style="font-size:11px; color:#6b7280; letter-spacing:0.4px;">
                  STATUS
                </th>
                <td mat-cell *matCellDef="let row" class="py-3 border-bottom">
                  <span class="badge rounded-pill px-3 py-1 fw-medium"
                        [ngClass]="getStatusClass(row.status)">
                    {{ getStatusLabel(row.status) }}
                  </span>
                </td>
              </ng-container>

              <!-- Delete Column (Conditional) -->
              @if (action().CanDelete) {
                <ng-container matColumnDef="delete">
                  <th mat-header-cell *matHeaderCellDef
                      class="text-center py-3 border-bottom bg-light"
                      style="width:60px; font-size:11px; color:#6b7280;">
                    DEL
                  </th>
                  <td mat-cell *matCellDef="let row"
                      class="text-center py-3 border-bottom">
                    <button mat-icon-button color="warn"
                            (click)="deleteTrip(row); $event.stopPropagation()"
                            matTooltip="Delete trip">
                      <i class="bx bxs-trash fs-5"></i>
                    </button>
                  </td>
                </ng-container>
              }

              <!-- Actions Column -->
              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef
                    class="py-3 border-bottom bg-light"
                    style="width:50px;"></th>
                <td mat-cell *matCellDef="let row"
                    class="py-3 border-bottom text-center">
                  <button mat-icon-button
                          [matMenuTriggerFor]="rowMenu"
                          [matMenuTriggerData]="{row: row}"
                          matTooltip="More actions"
                          (click)="$event.stopPropagation()">
                    <mat-icon>more_vert</mat-icon>
                  </button>
                </td>
              </ng-container>

              <!-- Header Row -->
              <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
              
              <!-- Data Rows -->
<tr mat-row
    *matRowDef="let row; columns: displayedColumns;"
    class="trip-row"
    (click)="openTripDetail(row)"
    style="cursor:pointer;"></tr>

<tr class="mat-row" *matNoDataRow>
  <td [attr.colspan]="displayedColumns.length"
      class="text-center py-5">
    <i class="bx bx-map-alt fs-1 d-block text-muted opacity-25 mb-2"></i>
    <p class="text-muted mb-1">No trips found</p>
    <small class="text-muted">Try adjusting your search or filters</small>
  </td>
</tr>
            </table>
          </div>

          <!-- Paginator -->
          <div class="border-top px-4 py-2 bg-white d-flex align-items-center
                      justify-content-between flex-shrink-0">
            <span class="small text-muted">
              Showing {{ dataSource.filteredData.length }} of {{ allTrips().length }} results
            </span>
            <mat-paginator [pageSizeOptions]="[10, 25, 50, 100]"
                           [pageSize]="10"
                           showFirstLastButtons>
            </mat-paginator>
          </div>

        </div>
      </div>
    </div>

  </div>
</div>

<!-- Context Menu -->
<!-- Context Menu -->
<mat-menu #rowMenu="matMenu">
  <ng-template matMenuContent let-row="row">
    <button mat-menu-item (click)="openTripDetail(row)">
      <mat-icon>visibility</mat-icon> View Details
    </button>
    <button mat-menu-item (click)="createQuote(row)">
      <mat-icon>description</mat-icon> Create Quote
    </button>
    @if (action().CanEdit) {
      <button mat-menu-item (click)="editTrip(row)">
        <mat-icon>edit</mat-icon> Edit Trip
      </button>
    }
    <!--<mat-divider></mat-divider>
    <button mat-menu-item (click)="updateStatus(row, 'progress')">
      <mat-icon>play_circle_outline</mat-icon> Mark In Progress
    </button>
    <button mat-menu-item (click)="updateStatus(row, 'hold')">
      <mat-icon>pause_circle_outline</mat-icon> Put On Hold
    </button>
     <button mat-menu-item (click)="updateStatus(row, 'converted')">
      <mat-icon>check_circle_outline</mat-icon> Mark Converted
    </button> -->
    @if (action().CanDelete) {
      <mat-divider></mat-divider>
      <button mat-menu-item (click)="deleteTrip(row)">
        <mat-icon color="warn">delete</mat-icon>
        <span class="text-danger">Delete Trip</span>
      </button>
    }
  </ng-template>
</mat-menu>
